import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { adminLogin, setAdminToken } from "@/lib/api";
import { toast, Toaster } from "sonner";
import { ShieldCheck, Phone, Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!phone || !password) { toast.error("Ingresa celular y contraseña"); return; }
    setLoading(true);
    try {
      const r = await adminLogin(phone.trim(), password);
      setAdminToken(r.token);
      toast.success("Bienvenido al centro de control");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciales inválidas");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen bg-[#050505] text-white flex items-center justify-center p-6 relative overflow-hidden" data-testid="admin-login">
      <div className="grain-overlay" />
      <div className="glow-orange" style={{ top: "-30%", left: "-15%" }} />
      <div className="glow-lime" style={{ bottom: "-30%", right: "-15%" }} />

      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md bg-[#0a0a0a]/80 backdrop-blur-xl border border-white/10 rounded-3xl p-8"
      >
        <div className="chip mb-4"><ShieldCheck size={12} className="text-[#ccff00]" /> Centro de control</div>
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter leading-none mb-2">
          Acceso <span className="text-[#ff5a00]">Admin</span>
        </h1>
        <p className="text-white/50 text-sm mb-8">Sólo para el equipo CHALANN.</p>

        <label className="block font-mono text-[10px] tracking-widest text-white/50 uppercase mb-2">Celular</label>
        <div className="flex items-center gap-2 bg-black/60 border border-white/10 rounded-2xl px-3 py-3 mb-4 focus-within:border-[#ff5a00]">
          <Phone size={16} className="text-white/40" />
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
            placeholder="10 dígitos"
            inputMode="numeric"
            className="flex-1 bg-transparent outline-none text-white placeholder-white/30"
            data-testid="admin-phone"
          />
        </div>

        <label className="block font-mono text-[10px] tracking-widest text-white/50 uppercase mb-2">Contraseña</label>
        <div className="flex items-center gap-2 bg-black/60 border border-white/10 rounded-2xl px-3 py-3 mb-6 focus-within:border-[#ff5a00]">
          <Lock size={16} className="text-white/40" />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••"
            className="flex-1 bg-transparent outline-none text-white placeholder-white/30"
            data-testid="admin-password"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-4 rounded-2xl bg-[#ff5a00] hover:bg-[#ff7a30] text-black font-display text-xl tracking-tighter flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="admin-login-submit"
        >
          {loading ? "Entrando…" : (<>Entrar <ArrowRight size={18} /></>)}
        </button>

        <button type="button" onClick={() => nav("/")} className="mt-4 w-full text-center text-white/40 hover:text-white text-xs font-mono uppercase tracking-widest">
          Volver al inicio
        </button>
      </motion.form>
      <Toaster theme="dark" position="top-center" />
    </main>
  );
}
